export default __webpack_public_path__ + "static/media/logo.1263bfd7.png";